app.directive('handlePopover', function () {
    return function (scope, element, attrs) {
        [element[0]].map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl,
                {
                    html: true,
                    content: function () {
                        return $(popoverTriggerEl).data("bs-content");
                    }
                })
        })

    };
});